<template>
	<div class="message">
		<div class="alert alert-info" role="alert">
			<h4 class="alert-heading">Suscripciones Escuela Sabática 2027</h4>
			<p>El plazo para suscribirse directamente en nuestra página web ha finalizado.</p>
			<p>Si no alcanzaste a realizar tu suscripción, tu Coordinador de Publicaciones podrá enviar, por e-mail, tu
				pedido a ACES hasta el 15 de septiembre.</p>
			<strong>¡No te quedes sin tu material para 2027!</strong>
		</div>
	</div>
</template>

<script>
export default {
	name: 'message',
}
</script>
